<template>
  <fragment>
    <AppBody
      title="Resumo do Evento"
      :subtitle="dashEvent.descricao"
      disableDivider
      backButton
    >
      <v-row>
        <v-col cols="12" :md="isTypeEvent ? 9 : 8" lg="9" class="pt-0">
          <v-row no-gutters>
            <v-col cols="12" :class="{ 'mb-3': isTypeEvent }">
              <v-card class="card-container" elevation="0">
                <v-card-title class="pt-0 px-2">
                  <v-icon color="#0F0F10" class="mr-2">
                    mdi-ticket-confirmation-outline
                  </v-icon>
                  {{
                    isTypeEvent
                      ? $t("producer-dashboard.tickets")
                      : $t("producer-dashboard.resume")
                  }}
                </v-card-title>
                <DashInfoModal type="tickets" />
              </v-card>
            </v-col>

            <v-col v-if="isTypeEvent" cols="12" md="6" class="pr-md-2">
              <v-card class="card-container" elevation="0">
                <v-card-title class="pt-0">
                  <v-icon color="#0F0F10" class="mr-2">mdi-tshirt-crew</v-icon>
                  {{ $t("producer-dashboard.products") }}
                </v-card-title>
                <DashInfoModal type="products" />
              </v-card>
            </v-col>

            <v-col
              v-if="isTypeEvent"
              cols="12"
              md="6"
              class="pl-md-2 pt-3 pt-md-0"
            >
              <v-card class="card-container" elevation="0">
                <v-card-title class="pt-0">
                  <v-icon color="#0F0F10" class="mr-2">mdi-card-plus</v-icon>
                  {{ $t("producer-dashboard.recharges") }}
                </v-card-title>
                <DashInfoModal type="recharges" />
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" :md="isTypeEvent ? 3 : 4" lg="3" class="pt-0">
          <v-card
            class="card-container d-flex flex-column"
            elevation="0"
            height="100%"
          >
            <v-card-title class="pt-0">Check-in</v-card-title>
            <DashCardCheckin :remaining="remaining" :achieved="achieved" />
          </v-card>
        </v-col>
      </v-row>

      <ReportDash
        @tab-changed="handleTabChange"
        class="mt-4"
        :actions="actions"
        :primaryLoading="loadingCSVExport"
        :secondaryLoading="loadingPDFExport"
      />
    </AppBody>
  </fragment>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import DashInfoModal from "@/components/cards/DashInfoModal.vue";
import DashCardCheckin from "@/components/cards/DashCardCheckin.vue";
import ReportDash from "@/components/cards/report/ReportDash.vue";
import AppBody from "@/layouts/components/AppBody.vue";

export default {
  name: "Resume",
  mixins: [displayHelpers],
  components: {
    DashInfoModal,
    DashCardCheckin,
    ReportDash,
    AppBody,
  },
  props: {
    isOpenModal: Boolean,
  },
  data() {
    return {
      expand: false,
      tab: 0,
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportPDF(),
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "idProduto",
      "descProduto",
      "storeList",
      "storeSequencial",
      "dashEvent",
      "dashEventLoading",
      "dashEventHasData",
      "checkinEvent",
      "saleTicket",
      "reportsFilter",
      "exportPDFLoading",
      "exportCSVLoading",
      "dashboardPDFLoading",
      "dashboardCSVLoading",
    ]),
    isTypeEvent() {
      return JSON.parse(localStorage.getItem("evento")).tipo === "EVENTO";
    },
    loadingCSVExport() {
      return this.tab === 0 ? this.dashboardCSVLoading : this.exportCSVLoading;
    },
    loadingPDFExport() {
      return this.tab === 0 ? this.dashboardPDFLoading : this.exportPDFLoading;
    },
    achieved() {
      if (Math.sign(this.checkinEvent.percentual_realizados) >= 1) {
        return {
          text: "Realizados",
          percentage: Math.round(this.checkinEvent.percentual_realizados),
          class: "positive-percent",
          value: this.checkinEvent.realizados,
        };
      } else {
        return {
          text: "Realizados",
          percentage: 0,
          class: "positive-percent",
          value: this.checkinEvent.realizados,
        };
      }
    },
    remaining() {
      if (Math.sign(this.checkinEvent.percentual_restantes) >= 1) {
        return {
          text: "Restantes",
          percentage: Math.round(this.checkinEvent.percentual_restantes),
          class: "positive-percent",
          value: this.checkinEvent.restantes,
        };
      } else {
        return {
          text: "Restantes",
          percentage: 0,
          class: "positive-percent",
          value: this.checkinEvent.restantes,
        };
      }
    },
  },
  methods: {
    ...mapActions([
      "getDashEvent",
      "exportDetailedSalesByEventPDF",
      "exportDetailedSalesByEventCSV",
      "exportSalesByDayPDF",
      "exportSalesByDayCSV",
      "exportSalesByChannelPDF",
      "exportSalesByChannelCSV",
      "exportSalesByPointOfSalePDF",
      "exportSalesByPointOfSaleCSV",
      "exportCancellationPDF",
      "exportCancellationCSV",
      "exportAffiliatesPDF",
      "exportAffiliatesCSV",
      "fetchDetailedSalesByEvent",
    ]),
    ...mapMutations([
      "setReportsFilter",
      "setIdProduto",
      "setDescProduto",
      "setDetailedSalesByEvent",
      "setSalesByDay",
      "setSalesByChannel",
      "setSalesByPointOfSale",
      "setCancellation",
      "setAffiliatesReport",
      "setDashEvent",
      "setDashCheckin",
    ]),
    handleTabChange(index) {
      this.tab = index;
    },
    exportPDF() {
      switch (this.tab) {
        case 0:
          this.exportDetailedSalesByEventPDF(this.reportsFilter);
          break;
        case 1:
          this.exportSalesByDayPDF(this.reportsFilter);
          break;
        case 2:
          this.exportAffiliatesPDF(this.reportsFilter);
          break;
        case 3:
          this.exportSalesByChannelPDF(this.reportsFilter);
          break;
        case 4:
          this.exportSalesByPointOfSalePDF(this.reportsFilter);
          break;
        case 5:
          this.exportCancellationPDF(this.reportsFilter);
          break;
      }
    },
    exportCSV() {
      switch (this.tab) {
        case 0:
          this.exportDetailedSalesByEventCSV(this.reportsFilter);
          break;
        case 1:
          this.exportSalesByDayCSV(this.reportsFilter);
          break;
        case 2:
          this.exportAffiliatesCSV(this.reportsFilter);
          break;
        case 3:
          this.exportSalesByChannelCSV(this.reportsFilter);
          break;
        case 4:
          this.exportSalesByPointOfSaleCSV(this.reportsFilter);
          break;
        case 5:
          this.exportCancellationCSV(this.reportsFilter);
          break;
      }
    },
    async getStorage() {
      const storage = JSON.parse(localStorage.getItem("evento"));

      this.setIdProduto(storage.idproduto);
      this.setDescProduto(storage.descricao);

      if (storage) {
        await this.fetchDetailedSalesByEvent({
          idproduto: this.idProduto,
          loja: this.storeSequencial,
        });
      }

      this.getDashEvent(storage);
    },
  },
  mounted() {
    this.getStorage();
    this.setReportsFilter({
      producerId: this.storeSequencial,
      idproduto: this.idProduto,
    });
  },
  destroyed() {
    this.setDescProduto("");
    this.setIdProduto("");
    this.setDetailedSalesByEvent({ info: [], totals: [] });
    this.setSalesByDay({ info: [], totals: [] });
    this.setSalesByChannel({ info: [], totals: [] });
    this.setSalesByPointOfSale({ info: [], totals: [] });
    this.setCancellation({ info: [], totals: [] });
    this.setAffiliatesReport({ info: [], totals: [] });
    this.setDashEvent({});
    this.setDashCheckin({});
  },
};
</script>
<style scoped>
.card-container {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px !important;
}
</style>
